import {ChangeDetectionStrategy, Component, ElementRef, inject, input, output} from "@angular/core";
import {toSignal} from "@angular/core/rxjs-interop";
import {TemaModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";
import {fromEvent} from "rxjs";
import {debounceTime, map, startWith} from "rxjs/operators";

@Component({
    selector: 'tema-med-beskrivelse',
    templateUrl: './tema-med-beskrivelse.html',
    styleUrl: './tema-med-beskrivelse.scss',
    host: {
        '(click)': 'klikkPaaTema()',
        'data-testid': 'tema-med-beskrivelse'
    },
    imports: [HtmlFormatertKomponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemaMedBeskrivelseKomponent {

    vedKlikk = output<TemaModell>();

    tema = input.required<TemaModell>();

    /** sann dersom dropdown med beskrivelse ved hover skal vises alignet med venstre kant av tema-tittel (aligner som standard med høyre kant) */
    erPaaVenstreSide = toSignal(fromEvent(window, 'resize').pipe(
        startWith(undefined),
        debounceTime(500),
        map(() => this.beskrivelseAlignerMedVenstreKant())
      ), {initialValue: false}
    );

    constructor(private el: ElementRef) {
    }

    klikkPaaTema() {
        this.vedKlikk.emit(this.tema());
    }

    //private hjelpemetoder

    private beskrivelseAlignerMedVenstreKant(): boolean {
        const rect = (this.el.nativeElement as HTMLElement).getBoundingClientRect();
        return rect.left < window.innerWidth / 2;
    }
}
